import i18n from '../../plugins/i18n';
import { CONSUMPTION_DEVICES_STATUSES } from '../../helpers/constants';

const configurations = {
  statusValuesList: getStatusesConfig(true),
  headersAktive: [
    { text: i18n.t('consumption_devices_table_headers.date'), value: 'date' },
    {
      text: i18n.t('consumption_devices_table_headers.applicant'),
      value: 'applicant',
    },
    {
      text: i18n.t('consumption_devices_table_headers.customer'),
      value: 'customer',
    },
    {
      text: i18n.t('consumption_devices_table_headers.connection_address'),
      value: 'address',
    },
    {
      text: i18n.t('consumption_devices_table_headers.product'),
      value: 'devices',
    },
    {
      text: i18n.t('consumption_devices_table_headers.last_edited_from'),
      value: 'lastChangedBy',
    },
    {
      text: i18n.t('consumption_devices_table_headers.status'),
      value: 'status',
      filterable: true,
      filter: (value) =>
        this.statusSelection === 'all' || value === this.statusSelection,
    },
    { value: 'edit' },
  ],
  countOrderStatuses: getStatusesConfig(false),
};

export const getConsumptionDevicesTableConfig = (configName) => {
  return JSON.parse(JSON.stringify(configurations[configName]));
};

function getStatusesConfig(isAllItemNeeded) {
  let statusesArray = [];
  statusesArray = Object.keys(CONSUMPTION_DEVICES_STATUSES).map((key) => {
    const { label, value, color, textColor } =
      CONSUMPTION_DEVICES_STATUSES[key];
    return { label, value, color, textColor };
  });
  if (isAllItemNeeded) {
    statusesArray.unshift({ label: 'alle', value: 'all', color: '#999999' });
  }
  return statusesArray;
}
